export default __webpack_public_path__ + "static/media/infrastructure-fund-checkout-banner-desktop.7148b10d.jpg";